import { ThemeConfig, theme } from 'antd';

/*
 * Infobulles sobres, partout. Elles héritaient de la couleur d'accent du thème
 * — fond vert et texte violet sur Leedflow — ce qui les rendait criardes alors
 * qu'une infobulle doit s'effacer derrière son contenu. `colorBgSpotlight` est
 * le fond, `colorTextLightSolid` le texte : les deux sont les jetons d'infobulle
 * chez Ant Design.
 */
const TOOLTIP_BG = '#f2f3f5';
const TOOLTIP_TEXT = '#1f2429';

export enum EThemeNames {
  LEEDFLOW_LIGHT = 'leedflow-light',
  LEEDFLOW_DARK = 'leedflow-dark',
  LEEDPULSE = 'leedpulse', // Legacy theme for nostalgia
}

export const leedflowLightTheme: ThemeConfig = {
  token: {
    colorPrimary: '#34C759',
    colorSuccess: '#10b981',
    colorWarning: '#ffc212',
    colorError: '#ff0022',
    colorInfo: '#9dccff',
    colorTextBase: '#2d3436',
    colorTextSecondary: '#636e72',
    colorBorder: '#e6f7f0',
    colorText: '#2d3436',
    colorBgSpotlight: TOOLTIP_BG,
    fontFamily: 'Work Sans',
    controlHeight: 40,
    borderRadiusLG: 20,
  },
  components: {
    Card: {
      colorBorderSecondary: '#f0f0f0',
    },
    Button: {
      fontWeight: 500,
      paddingContentHorizontal: 24,
    },
    Form: {
      itemMarginBottom: 32,
    },
    // In the client app this is the actual value
    // Input: {
    //   activeShadow: "0px 0px 10px #0aafff59",
    // },
    Menu: {
      itemColor: '#636e72',
      itemHoverColor: '#34C759',
      itemSelectedColor: '#2d3436',
      itemSelectedBg: '#e6f7f0',
      itemHoverBg: '#e6f7f0',
      itemActiveBg: '#00000010',
      activeBarBorderWidth: 2,
    },
    Table: {
      headerBg: '#e6f7f0',
    },
    Tooltip: {
      colorTextLightSolid: TOOLTIP_TEXT,
    },
    Select: {
      multipleItemBg: '#f0ebff',
    },
  },
};

const leedflowDarkTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: '#34C759',
    colorSuccess: '#10b981',
    colorWarning: '#ffc212',
    colorError: '#ff0022',
    colorInfo: '#9dccff',
    // Infobulle claire sur thème sombre, comme le fait Ant Design par défaut :
    // c'est le contraste avec le fond de page qui la détache.
    colorBgSpotlight: TOOLTIP_BG,
    fontFamily: 'Work Sans',
    controlHeight: 40,
    borderRadiusLG: 20,
  },
  components: {
    Card: {
      colorBorderSecondary: '#303030',
    },
    Button: {
      fontWeight: 500,
      paddingContentHorizontal: 24,
    },
    Form: {
      itemMarginBottom: 32,
    },
    Menu: {
      itemHoverColor: '#34C759',
      itemSelectedColor: '#34C759',
      itemSelectedBg: '#16311f',
      itemHoverBg: '#ffffff10',
      itemActiveBg: '#ffffff10',
      activeBarBorderWidth: 2,
    },
    Tooltip: {
      colorTextLightSolid: TOOLTIP_TEXT,
    },
  },
};


export const leedpulseTheme: ThemeConfig = {
  token: {
    colorPrimary: '#6737ff',
    colorSuccess: '#00f7bf',
    colorWarning: '#ffc212',
    colorError: '#ff0022',
    colorInfo: '#9dccff',
    colorTextBase: '#2d3436',
    colorTextSecondary: '#636e72',
    colorBorder: '#efebff',
    colorText: '#2d3436',
    colorBgSpotlight: TOOLTIP_BG,
    fontFamily: 'Work Sans',
    controlHeight: 40,
    borderRadiusLG: 20,
  },
  components: {
    Card: {
      colorBorderSecondary: '#f0f0f0',
    },
    Button: {
      fontWeight: 500,
      paddingContentHorizontal: 24,
    },
    Form: {
      itemMarginBottom: 32,
    },
    // In the client app this is the actual value
    // Input: {
    //   activeShadow: "0px 0px 10px #0aafff59",
    // },
    Menu: {
      itemColor: '#636e72',
      itemHoverColor: '#6737ff',
      itemSelectedColor: '#2d3436',
      itemSelectedBg: '#f0ebff',
      itemHoverBg: '#f0ebff',
      itemActiveBg: '#00000010',
      activeBarBorderWidth: 2,
    },
    Table: {
      headerBg: '#EFEBFF',
    },
    Tooltip: {
      colorTextLightSolid: TOOLTIP_TEXT,
    },
    Select: {
      multipleItemBg: '#f0ebff',
    },
  },
};

export const themePresets: Record<EThemeNames, ThemeConfig> = {
  [EThemeNames.LEEDFLOW_LIGHT]: leedflowLightTheme,
  [EThemeNames.LEEDFLOW_DARK]: leedflowDarkTheme,
  [EThemeNames.LEEDPULSE]: leedpulseTheme,
}